// extracted by mini-css-extract-plugin
module.exports = {"text":"ErrorModal_text__1Hq98"};